// src/components/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer className="bg-nebula-purple text-starlight-white p-6 text-center mt-auto shadow-white drop-shadow-lg">
      <p className="text-lg font-medium">Hosted by aqua and DuckEh</p>
      <div className="mt-2 border-t-2 border-starlight-white w-1/4 mx-auto"></div>
    </footer>
  );
}

export default Footer;
